import React from "react";
import T from "prop-types";
import { dollars } from "LIB/formatters/currency";
import { displayFloat, displayInt } from "LIB/formatters/number";
import { DataTable } from "MODULES/shared/components";
import { parse } from "query-string";
import _ from "lodash";

const renderDollarValues = (report, period, stat) => [
  <td className="text-center">
    {dollars(_.get(report, `current[0]${stat}`))}
  </td>,
  <td className="text-center">{dollars(_.get(report, `past[0]${stat}`))}</td>,
  period === "last_year" ? null : (
    <td className="text-center">
      {dollars(_.get(report, `average[0]${stat}`))}
    </td>
  )
];
const renderPercentValues = (report, period, stat) => [
  <td className="text-center">
    {displayFloat(_.get(report, `current[0]${stat}`))} %
  </td>,
  <td className="text-center">
    {displayFloat(_.get(report, `past[0]${stat}`))} %
  </td>,
  period === "last_year" ? null : (
    <td className="text-center">
      {displayFloat(_.get(report, `average[0]${stat}`))} %
    </td>
  )
];

const renderValues = (report, period, stat) => [
  <td className="text-center">
    {displayInt(_.get(report, `current[0]${stat}`))}
  </td>,
  <td className="text-center">
    {displayInt(_.get(report, `past[0]${stat}`))}
  </td>,
  period === "last_year" ? null : (
    <td className="text-center">
      {displayFloat(_.get(report, `average[0]${stat}`))}
    </td>
  )
];

const renderHeader = period => {
  switch (period) {
    case "week":
      return [
        <th className="text-center">Current Week</th>,
        <th className="text-center">Last Week</th>,
        <th className="text-center">Last Four Weeks (Avg/Week)</th>
      ];
    case "month":
      return [
        <th className="text-center">For Current Month</th>,
        <th className="text-center">For Last Month</th>,
        <th className="text-center">For Current Month (Projected)</th>
      ];
    case "quarter":
      return [
        <th className="text-center">For Current Quarter</th>,
        <th className="text-center">For Last Quarter</th>,
        <th className="text-center">For Current Quarter (Projected)</th>
      ];
    case "year":
      return [
        <th className="text-center">For Current Year</th>,
        <th className="text-center">For Last Year</th>,
        <th className="text-center">For Current Year (Projected)</th>
      ];
    case "last_year":
      return [
        <th className="text-center">For Last Year</th>,
        <th className="text-center">Two Years Ago</th>
      ];
    default:
      return [
        <th className="text-center">Today</th>,
        <th className="text-center">Yesterday (last working day)</th>,
        <th className="text-center">Current Month (Avg/Working Day)</th>
      ];
  }
};

export default function SellerReportTable({ results, isLoading }) {
  const { period } = parse(location.search);
  const report = results[0];

  return (
    <DataTable loading={isLoading} loadingRows={11} style={{ width: 0 }}>
      <DataTable.Head>
        <th />
        {renderHeader(period)}
      </DataTable.Head>
      <DataTable.Body>
        <tr>
          <th>Total Sold ($)</th>
          {renderDollarValues(report, period, "total_sales_all")}
        </tr>
        <tr>
          <th>Total Cancelled ($)</th>
          {renderDollarValues(report, period, "total_sales_cancelled")}
        </tr>
        <tr>
          <th>Total Non-Cancelled ($)</th>
          {renderDollarValues(report, period, "total_sales")}
        </tr>
        <tr>
          <th>#Outgoing Quote Lines Entered</th>
          {renderValues(report, period, "outgoing_quotes_count")}
        </tr>
        <tr>
          <th>#SO Lines</th>
          {renderValues(report, period, "so_line_items_count")}
        </tr>
        <tr>
          <th>#SO&apos;s Placed</th>
          {renderValues(report, period, "sos_placed")}
        </tr>
        <tr>
          <th>O-Quote to SO Conversion (By Lines) (%)</th>
          {renderPercentValues(report, period, "oq_to_so_conversion")}
        </tr>
        <tr>
          <th>#SO Lines Shared</th>
          {renderValues(report, period, "so_lines_shared")}
        </tr>
        <tr>
          <th>#SO Lines Shared (%)</th>
          {renderPercentValues(report, period, "so_lines_shared_percent")}
        </tr>
        <tr>
          <th># SO Line Cancellations</th>
          {renderValues(report, period, "so_line_cancellations")}
        </tr>
        <tr>
          <th>SO Cancellation %</th>
          {renderPercentValues(report, period, "so_cancellation_percent")}
        </tr>
      </DataTable.Body>
    </DataTable>
  );
}

SellerReportTable.propTypes = {
  results: T.arrayOf(T.shape({})).isRequired,
  isLoading: T.bool.isRequired
};



// WEBPACK FOOTER //
// ./app/modules/SalesDashboard/UserStats/SellerReportTable.jsx